import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private http: HttpClient) {}

  login(user: string, pass: string) {
    // most backend login endpoints on this project use GET with query parameters.
    // if your API eventually switches to a POST body, update this accordingly.
    const url =
      `${environment.apiUrl}/Login?UserName=${encodeURIComponent(user)}&UserPassword=${encodeURIComponent(
        pass
      )}`;
    return this.http.get<any>(url).pipe(
      map(res => {
        if (res && res.Response) {
          
          const saved = res.Response.User ? res.Response.User : res.Response;

          if (saved && saved.token) {
            localStorage.setItem('token', saved.token);
          }

          localStorage.setItem('currentUser', JSON.stringify(saved));
          localStorage.setItem('isLoggedIn', 'true');
        }
        return res;
      })
    );
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.setItem('isLoggedIn', 'false');
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  /**
   * Read and normalize current user from localStorage.  The login response used to
   * store `Response` which contained a `User` property; later we changed it to
   * save either the inner user or the whole response.  Callers can rely on the
   * same shape: object with `UserID`/`RoleName` etc.
   */
  getCurrentUser(): any {
    const raw = localStorage.getItem('currentUser');
    if (!raw) {
      return null;
    }
    try {
      const obj = JSON.parse(raw);
      return obj.User ? obj.User : obj;
    } catch {
      return null;
    }
  }
}
